import Vue from 'vue'
import {library} from '@fortawesome/fontawesome-svg-core'
import * as SolidIcons from '@fortawesome/free-solid-svg-icons'
import * as BrandIcons from '@fortawesome/free-brands-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

library.add(SolidIcons.faSearch);
library.add(SolidIcons.faTimes);
library.add(SolidIcons.faPlus);
library.add(SolidIcons.faMinus);
library.add(SolidIcons.faExpand);
Vue.component('font-awesome-icon', FontAwesomeIcon);

const title2icon = new Map([
    ["首页", "home"],
]);

export function getIcon(title) {
    return title2icon.get(title);
}
